import { DataDisplayEvent, Label, TableRow, CrudDecoratorCloseEvent, DataSourceMode } from "@mcleod/components";
import { AutogenLayoutUserGroupList } from "./autogen/AutogenLayoutUserGroupList";
export class UserGroupList extends AutogenLayoutUserGroupList {

    labelDefaultToIdOnDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (label.isEmpty())
            label.text = TableRow.getContainingTableRow(label)?.data?.get("id");
    }

    /** This is an event handler for the afterCrudClose event of tableGroups. */
    tableGroupsAfterCrudClose(event: CrudDecoratorCloseEvent) {
        if(event.dataSourceMode === DataSourceMode.ADD || event.dataSourceMode === DataSourceMode.UPDATE) {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
        }
    }
}
